import { gql } from "@apollo/client";

export const ADMIN_PROVISION_ORGANIZATION = gql`
  mutation AdminProvisionOrganization($data: AdminProvisionOrganizationInputType!) {
    adminProvisionOrganization(data: $data) {
      id
      name
    }
  }
`;

export const ADMIN_SEND_ORGANIZATION_ONBOARDING_EMAIL = gql`
  mutation AdminSendOrganizationOnboardingEmail($organizationId: String!) {
    adminSendOrganizationOnboardingEmail(organizationId: $organizationId)
  }
`;

export const ADMIN_UPDATE_ORGANIZATION_NOTIFICATION_SETTINGS = gql`
  mutation AdminUpdateOrganizationNotificationSettings(
    $data: AdminUpdateOrganizationNotificationSettingsInput!
  ) {
    adminUpdateOrganizationNotificationSettings(data: $data)
  }
`;
